var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"map-card"},[_c('div',{staticClass:"text-xs-center pt-3 pb-3"},[_vm._v("POWER FLOW")]),_c('v-divider',{staticClass:"custom-divider"}),_c('div',{staticClass:"flow-diagram pa-4"},[_c('FlowDiagram')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }